import Password from "components/view/join/email/pwd";
import { useRef } from "react";
import { useTranslation } from "react-i18next";

export default function PasswordPage() {
  const { t } = useTranslation();

  const pwdRef = useRef<HTMLDivElement>(null);

  return (
    <>
      <Password />
    </>
  );
}
